// Used to render the preview message body in Whatsapp Official
import formatWAMessage from "./formatWAMessage";

const renderWAPreviewBody = (
  source,
  body,
  isFromDataSource,
  parameterFormat
) => {
  let variableMap, renderedBody;

  if (parameterFormat === "positional") {
    if (isFromDataSource) {
      variableMap = {
        "{{1}}": source.bodyVariablePreview1
          ? source.bodyVariablePreview1
          : "{{1}}",
        "{{2}}": source.bodyVariablePreview2
          ? source.bodyVariablePreview2
          : "{{2}}",
        "{{3}}": source.bodyVariablePreview3
          ? source.bodyVariablePreview3
          : "{{3}}",
        "{{4}}": source.bodyVariablePreview4
          ? source.bodyVariablePreview4
          : "{{4}}",
        "{{5}}": source.bodyVariablePreview5
          ? source.bodyVariablePreview5
          : "{{5}}",
        "{{6}}": source.bodyVariablePreview6
          ? source.bodyVariablePreview6
          : "{{6}}",
        "{{7}}": source.bodyVariablePreview7
          ? source.bodyVariablePreview7
          : "{{7}}",
        "{{8}}": source.bodyVariablePreview8
          ? source.bodyVariablePreview8
          : "{{8}}",
        "{{9}}": source.bodyVariablePreview9
          ? source.bodyVariablePreview9
          : "{{9}}",
        "{{10}}": source.bodyVariablePreview10
          ? source.bodyVariablePreview10
          : "{{10}}",
      };
    } else {
      variableMap = {
        "{{1}}": source.bodyVariable1 ? source.bodyVariable1 : "{{1}}",
        "{{2}}": source.bodyVariable2 ? source.bodyVariable2 : "{{2}}",
        "{{3}}": source.bodyVariable3 ? source.bodyVariable3 : "{{3}}",
        "{{4}}": source.bodyVariable4 ? source.bodyVariable4 : "{{4}}",
        "{{5}}": source.bodyVariable5 ? source.bodyVariable5 : "{{5}}",
        "{{6}}": source.bodyVariable6 ? source.bodyVariable6 : "{{6}}",
        "{{7}}": source.bodyVariable7 ? source.bodyVariable7 : "{{7}}",
        "{{8}}": source.bodyVariable8 ? source.bodyVariable8 : "{{8}}",
        "{{9}}": source.bodyVariable9 ? source.bodyVariable9 : "{{9}}",
        "{{10}}": source.bodyVariable10 ? source.bodyVariable10 : "{{10}}",
      };
    }

    renderedBody = body.replace(
      /{{\d+}}/g,

      function (matched) {
        return variableMap[matched];
      }
    );
  } else {
    // Find every {{...}} pattern in the text
    const matches = body.match(/\{\{[^}]+\}\}/g) || [];

    // Build the mapping dynamically
    variableMap = Object.fromEntries(
      matches.map((pattern, index) => {
        const key = pattern; // e.g. "{{name}}", "{{foo}}", "{{123}}"

        // Build dynamic state field name
        const fieldName = isFromDataSource
          ? `bodyVariablePreview${index + 1}`
          : `bodyVariable${index + 1}`;

        // Use the stored value or fallback to the pattern itself
        const value = source[fieldName] || pattern;

        return [key, value];
      })
    );

    renderedBody = body.replace(
      /\{\{[^}]+\}\}/g,

      function (matched) {
        return variableMap[matched];
      }
    );
  }

  return formatWAMessage(renderedBody);
};

export default renderWAPreviewBody;
